import {
  ORDER_METHODS,
  SMART_PRICING_MODIFIER_TYPE,
  SMART_PRICING_RESOURCE_TYPE,
} from '../../../../../services/exports/Constants';

export default {
  title: {
    [SMART_PRICING_RESOURCE_TYPE.company]: 'Regulă globală de prețuri inteligente {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.franchise]: 'Regulă master de prețuri inteligente {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.menu]: 'Regulă de prețuri inteligente pentru meniu {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.category]: 'Regulă de prețuri inteligente pentru categorie {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.product]: 'Regulă de prețuri inteligente pentru produs {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.modifier_group]: 'Regulă de prețuri inteligente pentru grup de modificatori {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.modifier]: 'Regulă de prețuri inteligente pentru modificator {{name}}',
  },
  labels: {
    new: 'Nou',
    base_price: 'Prețul de bază {{name}}: {{value}}',
  },
  form: {
    resource: {
      [SMART_PRICING_RESOURCE_TYPE.menu]: 'Meniu',
      [SMART_PRICING_RESOURCE_TYPE.category]: 'Categorie',
      [SMART_PRICING_RESOURCE_TYPE.product]: 'Produs',
      [SMART_PRICING_RESOURCE_TYPE.modifier_group]: 'Grup de modificatori',
      [SMART_PRICING_RESOURCE_TYPE.modifier]: 'Modificator',
      placeholder: 'Selectați {{resource}}',
    },
    order_methods: {
      label: 'Metode de comandă',
      placeholder: 'Selectați metodele de comandă la care se aplică regula',
      options: {
        [ORDER_METHODS.pickup]: 'Ridicare',
        [ORDER_METHODS.delivery]: 'Livrare',
        [ORDER_METHODS.on_site]: 'Comenzi la masă',
      },
    },
    modifier_type: {
      label: 'Tip modificator de preț',
      placeholder: 'Selectați tipul modificatorului de preț',
      disabled_tooltip:
        'Absolut nu este disponibil pentru reguli la nivel de meniu, deoarece ar suprascrie prețul fiecărui articol.',
      tooltip: {
        title: 'Tipul modificatorului definește modul în care sunt modificate prețurile',
        description: {
          [SMART_PRICING_MODIFIER_TYPE.absolute]:
            'Absolut: suprascrie prețul resursei la valoarea specificată a modificatorului',
          [SMART_PRICING_MODIFIER_TYPE.percentage]:
            'Procentual: adaugă/scade procentul specificat al modificatorului din prețul de bază al resursei, în funcție de semnul valorii modificatorului',
          [SMART_PRICING_MODIFIER_TYPE.fixed_value]:
            'Valoare fixă: adaugă/scade valoarea fixă specificată din prețul de bază, în funcție de semnul valorii modificatorului',
        },
      },
      options: {
        [SMART_PRICING_MODIFIER_TYPE.absolute]: 'Absolut',
        [SMART_PRICING_MODIFIER_TYPE.percentage]: 'Procentual',
        [SMART_PRICING_MODIFIER_TYPE.fixed_value]: 'Valoare fixă',
      },
    },
    modifier_value: {
      label: 'Valoarea modificatorului de preț',
    },
    round: {
      label: 'Rotunjiți prețul rezultat',
      tooltip:
        'Rotunjește prețul rezultat în sus la 10 (ex. 14,91; 14,93; 14,99 devin 15,00). Util mai ales pentru regulile procentuale',
    },
    is_visible: {
      label: 'Afișați clientului ca ofertă',
    },
    name: {
      label: 'Nume',
      placeholder: 'Introduceți un nume ușor de înțeles pentru client',
      default: '{{value}} reducere la {{resource}}',
    },
  },
  buttons: {
    save: 'Salvați',
  },
  toasts: {
    failed_to_load_data: 'Încărcarea datelor a eșuat',
    failed_to_save_changes: 'Salvarea modificărilor a eșuat',
    changes_got_saved: 'Modificările au fost salvate',
  },
};
